__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__V3pCDW__accordion",
  "bottomBorder": "Accordion-module-scss-module__V3pCDW__bottomBorder",
  "content": "Accordion-module-scss-module__V3pCDW__content",
  "header": "Accordion-module-scss-module__V3pCDW__header",
});
